import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../styles/HeroSection.css';

import bgVideo from '../../assets/Malaysia-Environment.mp4';

export default function HeroSection() {
  return (
    <section className="hero-section position-relative">
      {/* Background Video */}
      <video className="hero-video" autoPlay muted loop playsInline>
        <source src={bgVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Dark overlay */}
      <div className="hero-overlay-dark"></div>

      {/* Swiper Slider */}
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        effect="fade"
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        navigation={true}
        className="hero-swiper"
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="hero-slide-content text-center text-white">
            <h1 className="display-4 fw-bold">Smart Hiring Starts with the Right Partner</h1>
            <p className="lead mt-3">
              We simplify how businesses expand into Malaysia with EOR, Immigration, and Recruitment Solutions.
            </p>
            <a href="/contact" className="btn btn-outline-light btn-lg mt-3">
              <i className="bi bi-envelope-fill me-2"></i>Talk to Us
            </a>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="hero-slide-content text-center text-white">
            <h1 className="display-4 fw-bold">Full Compliance, Zero Hassle</h1>
            <p className="lead mt-3">
              We manage payroll, tax, and HR — so you can focus on scaling your team.
            </p>
            <a href="/services" className="btn btn-outline-light btn-lg mt-3">
              <i className="bi bi-briefcase-fill me-2"></i>Our Services
            </a>
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <div className="hero-slide-content text-center text-white">
            <h1 className="display-4 fw-bold">Hire Talent Across Borders</h1>
            <p className="lead mt-3">
              We help companies bring top global talent into Malaysia legally and efficiently.
            </p>
            <a href="/expatriate-support" className="btn btn-outline-light btn-lg mt-3">
              <i className="bi bi-globe me-2"></i>Explore Expat Support
            </a>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
}
